import { SnapshotTrigger } from './picture-filter.type';
import { Daytime } from './time-filter.type';
import { VideoAvailability } from './video-filter.type';

export type FilterByOtherCriteriaType = VideoAvailability | SnapshotTrigger | Daytime;

export const FilterByOtherCriteriaValues = [...Object.values(VideoAvailability), ...Object.values(SnapshotTrigger), ...Object.values(Daytime)];
